import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChartCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 178,
	height: 129,
	viewBox: "0 0 178 129",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_493_11064",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 178,
			height: 129,
			children: /* @__PURE__ */ _jsx("rect", {
				width: 178,
				height: 129,
				fill: "#D9D9D9"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_493_11064)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 89,
				cy: 89,
				r: 88.5,
				stroke: "url(#paint0_linear_493_11064)"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_493_11064",
			x1: 89,
			y1: 0,
			x2: 89,
			y2: 129,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				stopColor: "#DFCBF5",
				stopOpacity: .7
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#DFCBF5",
				stopOpacity: 0
			})]
		}) })
	]
});
export default SvgChartCircle;
